import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruckRegistrationMasterdataComponent } from './truck-registration-masterdata.component';
import { DictionaryModule } from '@sdbn/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { CenteredScrollableContentModule } from '@sdbn/tmc-common';


import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    TruckRegistrationMasterdataComponent
  ],
  imports: [
    CommonModule,
    CenteredScrollableContentModule,
    DictionaryModule,

    FormsModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,

    MatFormFieldModule,
    MatInputModule
  ]
})
export class TruckRegistrationMasterdataModule { }
